import { styled } from '@mui/material/styles';
import Typography, { type TypographyProps } from '@mui/material/Typography';

const StyledComponent = styled(Typography)({
  whiteSpace: 'pre-wrap',
});

export const TextWithLineBreaks = (props: TypographyProps) => (
  <StyledComponent {...props} />
);

export default TextWithLineBreaks;
